module.exports = __webpack_public_path__ + "img/2022-17.87d2e4da.jpg";